<div class="members-main-wrapper">
  <button class="toggle-sidebar" (click)="toggleSidebar($event)">
    <span class="arrow-left"><i class="material-icons">keyboard_arrow_left</i></span>
    <span class="arrow-right"><i class="material-icons">keyboard_arrow_right</i></span>
  </button>
  <app-side-bar></app-side-bar>
  <app-member-header></app-member-header>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
